import { render, staticRenderFns } from "./SortingOrders.vue?vue&type=template&id=8aeed9e2&scoped=true&"
import script from "./SortingOrders.vue?vue&type=script&lang=js&"
export * from "./SortingOrders.vue?vue&type=script&lang=js&"
import style0 from "./SortingOrders.vue?vue&type=style&index=0&id=8aeed9e2&lang=scss&scoped=true&"
import style1 from "./SortingOrders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeed9e2",
  null
  
)

export default component.exports